<template>
  <div
    class="relative flex gap-2 b rounded-xs bg-grey-90 px-2 py-4"
    :class="modelValue === type ? 'b-grey-10' : 'b-transparent'"
  >
    <vf-icon  :name="icon" size="md" />
    <span class="w-full f-col gap-1 text-sm">
      <base-radio
        v-if="selectable"
        v-model="modelValue"
        :aria-describedby="[type === 'pickup' ? 'pickup-store' : '', `${type}-description`].join(' ')"
        class="|static"
        :name="type"
        :value="type"
        @change="$emit('change', $event)"
      >
        <span class="fw-medium peer-focus-visible:outline-auto">
          {{ label }}
        </span>
        <span v-if="modelValue !== type" class="absolute-0 cursor-pointer" />
      </base-radio>
      <span v-else class="fw-medium ">
        {{ label }}
      </span>
      <span v-if="type === 'standard'" id="standard-description" class="fw-light">
        <span class="f-col gap-1">
          <product-shipping-methods-estimated-delivery v-if="showEdd && variant?.buyable" :variant />
          <template v-else>
            <span>
              {{ $t.standardShipping }}
            </span>
            <span v-if="description">
              {{ description }}
            </span>
          </template>
        </span>
      </span>
      <template v-else-if="type === 'pickup'">
        <span v-if="selectedStore" id="pickup-store" class="fw-light">
          {{ selectedStore.name }}
        </span>
        <base-button class="relative z-1 self-start py-px underlined" @click="$emit('open-search')">
          {{ selectedStore ? $t.changeStore.title : $t.findStore }}
        </base-button>
        <span v-if="description" id="pickup-description" class="fw-light" :class="{ 'c-red-30': error }">
          {{ description }}.
        </span>
      </template>
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { LocatorSearchItem } from '#types/brandify'
import type { IconName } from '#types/icon'
import type { SelectedVariant } from '#types/product'

declare global {
  interface Window {
    narvar: (targetElement: string, config: object) => void
  }
}

const { selectable = true } = defineProps<{
  description?: string
  error?: boolean
  icon?: IconName
  label: string
  selectable?: boolean
  selectedStore?: LocatorSearchItem
  showEdd?: boolean
  type: 'standard' | 'pickup'
  variant?: SelectedVariant
}>()

defineEmits<{
  'change': [value: string]
  'open-search': []
}>()

const modelValue = defineModel<string>()
</script>
